import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index'
import Home from '@/views/Home'
import EnterpriseRoute from '@/views/EnterpriseRoute'
import EnterpriseIndex from '@/views/EnterpriseIndex'
import EnterpriseTech from '@/views/EnterpriseTech'
import BizScope from '@/views/BizScope'
import BizScopeDetail from '@/views/BizScopeDetail'
import Case from '@/views/Case'
import CaseDetail from '@/views/CaseDetail'
import Honor from '@/views/Honor'
import News from '@/views/News'
import NewsDetail from '@/views/NewsDetail'
import Contact from '@/views/Contact'

import Protocol from '@/views/Protocol'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
        path: 'enterprise',
        name: 'enterprise',
        component: EnterpriseRoute,
        children: [
          {
            path: 'intro',
            name: 'enterpriseIndex',
            component: EnterpriseIndex
          },
          {
            path: 'tech',
            name: 'enterpriseTech',
            component: EnterpriseTech
          }
        ]
      },
      {
        path: 'biz-scope',
        name: 'bizScope',
        component: BizScope
      },
      {
        path: 'biz-scope-detail/:id',
        name: 'bizScopeDetail',
        component: BizScopeDetail
      },
      {
        path: 'case',
        name: 'case',
        component: Case
      },
      {
        path: 'case-detail/:id',
        name: 'caseDetail',
        component: CaseDetail
      },
      {
        path: 'honor',
        name: 'honor',
        component: Honor
      },
      {
        path: 'news',
        name: 'news',
        component: News
      },
      {
        path: 'news-detail/:id',
        name: 'newsDetail',
        component: NewsDetail
      },
      {
        path: 'contact',
        name: 'contact',
        component: Contact
      },
    ]
  }, 
  {
    path: '/protocal/:gcode/:code',
    name: 'protocal',
    component: Protocol
  }

]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) { // 回退操作
      return savedPosition
    } else { // 新页面导航
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
